import React, { useState } from "react";
import { exportCSV } from "../services/api.js";

export default function ExportPanel(){
  const [table, setTable] = useState("trades");
  const [period, setPeriod] = useState("monthly");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [msg, setMsg] = useState("");

  const download = async () => {
    try{
      setMsg("Erstelle Export…");
      const blob = await exportCSV(table, period, start || undefined, end || undefined);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = `${table}_${period}.csv`; document.body.appendChild(a); a.click(); a.remove();
      window.URL.revokeObjectURL(url);
      setMsg("Download gestartet.");
    }catch(e){ setMsg(`Fehler: ${e.message}`); }
  };

  return (
    <div className="card">
      <div className="font-semibold mb-2">Export</div>
      <div className="grid grid-cols-2 gap-2 text-sm">
        <label>Table
          <select className="w-full border rounded px-2 py-1" value={table} onChange={e=>setTable(e.target.value)}>
            <option value="trades">Trades</option>
            <option value="analyses">Analysen</option>
            <option value="events">Events</option>
            <option value="equity">Equity</option>
          </select>
        </label>
        <label>Periode
          <select className="w-full border rounded px-2 py-1" value={period} onChange={e=>setPeriod(e.target.value)}>
            <option value="monthly">Monatlich</option>
            <option value="quarterly">Quartal</option>
            <option value="yearly">Jährlich</option>
            <option value="custom">Custom</option>
          </select>
        </label>
        {period === "custom" && (<>
          <label>Start
            <input type="date" className="w-full border rounded px-2 py-1" value={start} onChange={e=>setStart(e.target.value)} />
          </label>
          <label>Ende
            <input type="date" className="w-full border rounded px-2 py-1" value={end} onChange={e=>setEnd(e.target.value)} />
          </label>
        </>)}
      </div>
      <div className="mt-3">
        <button className="btn btn-primary" onClick={download}>CSV herunterladen</button>
        {msg && <div className="text-xs opacity-80 mt-1">{msg}</div>}
      </div>
    </div>
  );
}